import React from 'react'
import LoadingSpinner, {LoadingSpinnerSize} from '../../common/LoadingSpinner'

const InvoiceLoading: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-8 w-full">
      <LoadingSpinner size={LoadingSpinnerSize.Medium} />
      <p className="text-sm text-gray-600 mt-4 italic">
        Generating invoices...
      </p>
    </div>
  )
}

export default InvoiceLoading
